/**
 * Foreground handler for the mobile "Server not responding" bug: returning to the
 * foreground re-syncs the network state and forces an immediate API probe, so the
 * connectivity machine recovers without a reload. Lives outside the provider so the
 * rule is testable without mounting PowerSync.
 */
export function createForegroundReprobe(
  manager: {
    handlers: { onNetworkChanged: (online: boolean) => void };
    forceHealthCheck: () => Promise<void> | void;
  },
  env: { visibilityState: () => string; online: () => boolean },
): () => void {
  return () => {
    if (env.visibilityState() !== "visible") {
      return;
    }
    manager.handlers.onNetworkChanged(env.online());
    void manager.forceHealthCheck();
  };
}
